Namespace 'Customer.Dashboard'

class Customer.Views.Reports.OperatorAvailabilityTableRowPlaceholder extends Backbone.View
  template: JST['backbone/templates/customer/reports/operator_availability/operator_availability_table_row_placeholder']
  className: 'operator-availability-table-row report-row-placeholder'

  @contentHeight: 38

  initialize: ({pendingIncluded}) =>
    @pendingIncluded = pendingIncluded

  render: ->
    @$el.html @template(pendingIncluded: @pendingIncluded)
    @_adjustPlaceholders()
    @

  destroy: ->
    false

  _adjustPlaceholders: =>
    @_loginStatusIconDiv().css('width', "#{@_loginStatusIconWidth()}px")
    @$el.find('.operator-login-status-value').css('width', "#{@_loginStatusValueWidth()}px")
    @$el.find('.report-operator').css('width', "#{@_reportOperatorWidth()}px")
    @$el.find('.report-group').css('width', "#{@_reportGroupWidth()}px")
    @_reportStatusDiv().css('width', "#{@_reportStatusWidth()}px")
    @_reportStatusColor()
    @_reportOperatorLoginStatusColor()
    @$el.find('.report-operator-status-time').css('width', "#{@_reportOperatorStatusTimeWidth()}px")
    @$el.find('.report-ticket-count').css('width', "#{@_reportTicketCountWidth()}px")
    @$el.find('.report-average-time').css('width', "#{@_reportAverageWidth()}px")

  _reportOperatorLoginStatusColor: =>
    colorIndex = @_randomNumberInRange(0, 1)
    div = @_loginStatusIconDiv()
    colors = [@_applyGreenStatus, @_applyRedStatus]
    colors[colorIndex](div)

  _loginStatusIconWidth: ->
    @_randomNumberInRange(14, 14)

  _loginStatusValueWidth: ->
    @_randomNumberInRange(75, 180)

  _reportOperatorWidth: =>
    @_randomNumberInRange(75, 180)

  _reportGroupWidth: =>
    @_randomNumberInRange(125, 180)

  _reportStatusWidth: =>
    @_randomNumberInRange(75, 125)

  _reportStatusColor: =>
    colorIndex = @_randomNumberInRange(0, 2)
    div = @_reportStatusDiv()
    colors = [@_applyGreenStatus, @_applyYellowStatus, @_applyRedStatus]
    colors[colorIndex](div)

  _reportOperatorStatusTimeWidth: =>
    @_randomNumberInRange(75, 100)

  _reportTicketCountWidth: =>
    75

  _reportAverageWidth: =>
    @_randomNumberInRange(75, 100)

  _applyGreenStatus: (div) =>
    div.removeClass('default-background-unmasker').addClass('green-background-unmasker')

  _applyYellowStatus: (div) =>
    div.removeClass('default-background-unmasker').addClass('yellow-background-unmasker')

  _applyRedStatus: (div) =>
    div.removeClass('default-background-unmasker').addClass('red-background-unmasker')

  _reportStatusDiv: ->
    @$el.find('.report-status')

  _loginStatusIconDiv: ->
    @$el.find('.operator-login-status-icon')

  _randomNumberInRange: (lower, upper) ->
    Math.floor(Math.random() * (upper - lower + 1) + lower)
